import type { CharacterProfile } from '../types';
import { VERSUS_EXPLOSION_MS, VERSUS_FIGHT_MS } from '../data/characterSelect';
import { IdleFighterSprite } from './IdleFighterSprite';
import { EasterEggCameo } from './EasterEggCameo';
import { FightImpactOverlay } from './FightImpactOverlay';
import type { EasterEggId } from '../lib/easterEggProgress';

interface VersusAttractSceneProps {
  cameo?: CharacterProfile;
  elapsedMs: number;
  fastMode: boolean;
  left?: CharacterProfile;
  matchupKey?: string;
  onPause: () => void;
  onResume: () => void;
  onDiscover: (id: EasterEggId) => void;
  paused: boolean;
  right?: CharacterProfile;
  stage: string;
}

export function VersusAttractScene({ cameo, elapsedMs, fastMode, left, matchupKey, onPause, onResume, onDiscover, paused, right, stage }: VersusAttractSceneProps) {
  if (!left || !right) return <main className="attract-scene versus-attract versus-attract--missing"><h1>CHALLENGER SIGNAL LOST</h1></main>;
  const fight = elapsedMs >= VERSUS_FIGHT_MS;
  const explosion = elapsedMs >= VERSUS_EXPLOSION_MS;
  return (
    <main className={`attract-scene versus-attract${fight ? ' is-engaging' : ''}`} aria-label={`${left.name} versus ${right.name} at ${stage}`}>
      <div className="versus-attract__fighter versus-attract__fighter--left"><IdleFighterSprite character={left} side="left" paused={paused} fastMode={fastMode} /><div><span>{left.nickname}</span><h1>{left.name}</h1><b>{left.fightingStyle}</b></div></div>
      <div className="versus-attract__emblem" aria-hidden="true">VS</div>
      <div className="versus-attract__fighter versus-attract__fighter--right"><IdleFighterSprite character={right} side="right" paused={paused} fastMode={fastMode} /><div><span>{right.nickname}</span><h1>{right.name}</h1><b>{right.fightingStyle}</b></div></div>
      <p className="versus-attract__stage">STAGE // {stage}</p>
      <FightImpactOverlay fight={fight} explosion={explosion} />
      {cameo && matchupKey && <EasterEggCameo cameo={cameo} elapsedMs={elapsedMs} leftName={left.name} rightName={right.name} matchupKey={matchupKey} onPause={onPause} onResume={onResume} onDiscover={onDiscover} />}
    </main>
  );
}
